<template>
  <form class="grid grid-cols-1 lg:grid-cols-2 col-gap-12 row-gap-11 items-start" @submit.prevent="create">
    <div class="text-xl font-bold text-text leading-tight mb-4 col-span-2">{{ $t('formTitle') }}</div>
    <BaseSelect v-model="subject"
                :options="ticketSubject"
                label="name"
                :select-label="$t('sectionLabel')"
                :allow-empty="false"
                :searchable="false"
                :show-labels="false"/>
    <BaseInput v-model.trim="$v.title.$model"
               :label="$t('themeLabel')"
               :class="{'--error':$v.title.$error }">
      <template v-slot:errors="">
        <div class="error" v-if="!$v.title.required">{{ $t('errors.required') }}</div>
      </template>
    </BaseInput>
    <BaseTextarea v-model.trim="$v.message.$model"
                  class="col-span-2"
                  :label="$t('textLabel')"
                  :class="{'--error':$v.message.$error }"
                  @keydown.shift.enter="create">
      <template v-slot:errors="">
        <div class="error" v-if="!$v.message.required">{{ $t('errors.required') }}</div>
        <div class="error" v-if="!$v.message.minLength">{{ $t('messageMinLength') }}</div>
      </template>
    </BaseTextarea>
    <BaseButton @click="create"
                theme="red"
                :loading="submitted"
                class="w-full lg:w-91">
      {{ $t('send') }}
    </BaseButton>
    <FileUpload v-model="attachments"
                class="pt-4"
                :accept="['zip', 'rar', 'jpg', 'jpeg', 'png', 'gif', 'pdf', 'csv', 'xls', 'xlsx']"
                ref="files"/>
  </form>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {minLength, required} from "vuelidate/lib/validators";
import BaseTextarea from "@/components/UI/BaseTextarea";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseButton from "@/components/UI/BaseButton";
import FileUpload from "@/components/common/FileUpload";

export default {
  name: "TicketSystemAddForm",
  components: {FileUpload, BaseButton, BaseInput, BaseSelect, BaseTextarea},
  data() {
    return {
      subject: null,
      title: '',
      message: '',
      submitted: false,
      attachments: []
    }
  },
  computed: {
    ...mapGetters('cabinet/constants', ['getConstantList']),
    ticketSubject() {
      return this.getConstantList('ticket_subject')
    },
  },
  validations: {
    title: {
      required,
    },
    message: {
      required,
      minLength: minLength(5)
    },
  },
  methods: {
    ...mapActions('cabinet/tickets', ['createTicket', 'setCurrentTicket']),
    async create() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.submitted = true;
        try {
          let formData = new FormData();
          formData.append('title', this.title);
          formData.append('message', this.message);
          formData.append('subject', this.subject.id);
          if (this.attachments.length > 5) {
            this.$toasted.error(this.$t('availableFilesError'))
            return;
          }
          if (!!this.attachments) {
            this.attachments.forEach(file => {
              formData.append('files[]', file);
            });
          }

          const res = await this.createTicket(formData);
          if (res.body.success) {
            this.title = '';
            this.message = '';
            this.attachments = [];
            this.subject = this.ticketSubject[0];
            this.$v.$reset();
            this.$toasted.success('Тикет создан')

            this.setCurrentTicket(res.body.data)
            this.$router.push({name: 'ticket-chat', params: {ticketId: res.body.data.id}})
          } else {
            Object.values(res.body.message).forEach((item) => {
              if (typeof item === 'string') this.$toasted.error(item, {duration: 5000})
            })
            console.error(res)
          }
        } catch (err) {
          console.log(err)
        } finally {
          this.submitted = false;
        }
      } else {
        this.$toasted.error('Проверьте поля')
      }
    }
  },
  mounted() {
    this.subject = this.ticketSubject[0]
  },
  i18n: {
    messages: {
      en: {
        formTitle: 'Write to us',
        sectionLabel: 'Section',
        themeLabel: 'Title',
        textLabel: 'Message',
        send: 'Send',
        messageMinLength: 'Сообщение должно содержать минимум 5 символов',
        availableFilesError: 'Only 5 files available for download'
      },
      ru: {
        formTitle: 'Напишите нам',
        sectionLabel: 'Раздел',
        themeLabel: 'Тема',
        textLabel: 'Текст',
        send: 'Отправить',
        messageMinLength: 'Сообщение должно содержать минимум 5 символов',
        availableFilesError: 'Доступно для загрузки только 5 файлов'
      }
    }
  }
}
</script>